import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-12 md:py-16 lg:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm font-medium mb-3">
            <i className="ri-fire-line"></i>
            <span>实时热度</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            综合连载人气、讨论热度与更新活跃度，实时呈现韩漫、日漫、国漫各领域的头部佳作
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
            {rankingData.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 ${idx !== rankingData.length - 1 ? 'border-b border-background-200/70' : ''} hover:bg-background-200/50 transition-colors`}
              >
                {/* Rank Number */}
                <div
                  className={`shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center font-heading font-bold text-sm md:text-base ${
                    item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  <span className={item.rank <= 3 ? 'text-background-50' : 'text-foreground-600'}>
                    {item.rank}
                  </span>
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className={`text-xs px-2 py-0.5 rounded font-medium
                      ${item.category === '韩漫' ? 'bg-accent-100 text-accent-900' :
                        item.category === '日漫' ? 'bg-primary-100 text-primary-700' :
                        'bg-secondary-100 text-secondary-700'}`}>
                      {item.category}
                    </span>
                    <span className="text-xs text-foreground-500">{item.type}</span>
                  </div>
                </div>

                {/* Heat indicator */}
                <div className="shrink-0 flex items-center gap-1.5">
                  <div className="hidden sm:flex items-center gap-1 w-20">
                    <div className="h-1.5 rounded-full bg-background-300 flex-1 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-primary-400"
                        style={{ width: `${item.heat}%` }}
                      />
                    </div>
                  </div>
                  <span className="text-xs md:text-sm font-semibold text-primary-600 whitespace-nowrap">
                    {item.heat}°
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}